import Typography from "@mui/material/Typography";
import { Button, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from "@mui/material";
import { useRecoilState } from "recoil";
import { deepCopy, isValidEmail } from "../../helpers/utils";
import { IComponent, IDashboard, IInstallation } from "../../common-interfaces/interfaces";
import { selectedInstallationAtom, isLoadingAtom } from "../../recoil/atoms";
import { useOnGet } from "../../hooks/useOnGet";
import { useOnSet } from "../../hooks/useOnSet";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ShareIcon from '@mui/icons-material/Share';
import { FC, useState } from "react";
import ReactLoading from "react-loading";
import { ControlWhiteDialog } from "../../theme";

const ShareButton: FC<{ argument: 'dashboard' | 'component', body: IDashboard | IComponent }> = ({ argument, body }) => {
  const [emailTo, setEmailTo] = useState<string>("");
  const [validEmail, setValidEmail] = useState<boolean>(true);
  const [open, setOpen] = useState(false);
  const [err, setErr] = useState("");

  const [selectedInstallation] = useRecoilState<IInstallation>(selectedInstallationAtom);
  const [isLoading, setIsloading] = useRecoilState<boolean>(isLoadingAtom);
  const GET = useOnGet();
  const SET = useOnSet();

  const handleDialogClose = () => {
    setOpen(false);
  };

  const handleNewEmailTo = (ev: any) => {
    setErr("");
    setEmailTo(ev.target.value);
  };

  return (
    <>
      <Button
        size="small"
        color="apple"
        variant="contained"
        title='Share Dashboard'
        disabled={isLoading}
        onClick={() => setOpen(true)}
      >
        <ShareIcon sx={{ color: '#ccc' }} />
      </Button>
      <ControlWhiteDialog open={open} onClose={handleDialogClose} fullWidth>
        <DialogTitle>SHARE {argument.toUpperCase()}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Enter the installer email to share {argument}
          </DialogContentText>
          {!isLoading && (
            <TextField
              className="searchInput"
              id="installationName"
              sx={[
                { mt: 1, maxWidth: "400px", minWidth: "400px" },
                {
                  "& .MuiFormHelperText-root.Mui-error": {
                    color: "#d32f2f !important",
                  },
                },
              ]}
              label="Installer Email"
              type="email"
              variant="standard"
              error={err !== ""}
              onBlur={() => {
                setValidEmail(isValidEmail(emailTo));
              }}
              value={emailTo}
              onChange={(ev) => handleNewEmailTo(ev)}
              helperText={
                !validEmail ? "Please enter a valid email address" : err ?? ""
              }
            />
          )}
          {isLoading && (
            <ReactLoading type={"bars"} color={"#fff"} width={"60px"} />
          )}
        </DialogContent>
        <DialogActions>
          <Button
            disabled={!emailTo || !validEmail || err !== ""}
            onClick={console.log}
          >
            Share
          </Button>
          <Button onClick={handleDialogClose}>Cancel</Button>
        </DialogActions>
      </ControlWhiteDialog>
    </>
  );
}
export default ShareButton